<div class="card shadow-lg" [style.background-color]="bgColor">
  <div class="card-content">
    <div class="card-body">
      <div class="media d-flex">
        <div class="align-self-center">
          <i [ngClass]="icon" class="float-left" [style.color]="fontColor" [style.font-size]="'170%'"></i>
        </div>
        <div class="media-body text-right">
          <h4 [style.font-weight]="'bold'" [style.color]="fontColor" class="font-audiowide">{{ (value | number ) || '...'}}</h4>
          <span [style.color]="titleColor" class="font-audiowide">{{title}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
